import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { apiError } from "@/lib/platform";

export const EvidenceUploadButton = ({ requestId, category, systemActionId, verificationId, onUploaded, label = "Attach", testId, size = "sm",
  endpoint, fields = {} }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("category", category);
    if (systemActionId) fd.append("system_action_id", systemActionId);
    if (verificationId) fd.append("verification_id", verificationId);
    Object.entries(fields).forEach(([k, val]) => val && fd.append(k, val));
    setBusy(true);
    try {
      const { data } = await api.post(endpoint || `/rights/${requestId}/evidence`, fd);
      toast.success(`${data.reference_number} attached`);
      onUploaded?.();
    } catch (err) {
      toast.error(apiError(err, "Upload failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={ref} type="file" className="hidden" onChange={upload} data-testid={`${testId}-input`} />
      <Button type="button" size={size} variant="outline" disabled={busy} onClick={() => ref.current?.click()}
              className="h-7 text-[11px] px-2" data-testid={testId}>
        <Paperclip className="w-3 h-3 mr-1" /> {busy ? "Uploading…" : label}
      </Button>
    </>
  );
};
